'use client';

import {MouseEvent, useState} from 'react';
import {MenuItem, MenuItemProps} from './MenuItem';

interface ManuItemConfirmProps extends Omit<MenuItemProps, 'autoClose'> {
  message: string;
}

export const MenuItemConfirm = ({children, message, onClick, ...rest}: ManuItemConfirmProps) => {
  const [preConfirm, setPreConfirm] = useState(false);

  const onClickComputed = (e: MouseEvent<HTMLDivElement>) => {
    if (preConfirm && onClick) {
      onClick(e);
      return;
    }
    setPreConfirm(true);
  };

  return (
    <MenuItem
      {...rest}
      autoClose={preConfirm}
      onClick={onClickComputed}
      onMouseDown={(e) => e.preventDefault()}
    >
      {preConfirm ? message : children}
    </MenuItem>
  );
};
